module.exports = __webpack_public_path__ + "static/media/055-Paddy Flahertys.2ba99a5f.png";